import React, { Fragment, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import Signin from "../Auth/Signin";
import LayoutRoutes from "./LayoutRoutes";
import { authRoutes } from "./AuthRoutes";
import PrivateRoute from "./PrivateRoute";
import ScrollToTop from "../Services/ScrollToTop";
import { AuthProvider } from "../Context/AuthContext";
import PDFViewerComponent from "../Component/Transaksi/PDF/PDFViewer";
import PDFViewerComponentUMK from "../Component/Uang Muka/UMK/PDF/PDFViewer";
import PDFViewerComponentTandaDiterima from "../Component/Transaksi/PDFTandaTerima/PDFViewer";
import PDFViewerComponentUMO from "../Component/Uang Muka/Operasional/PDF/PDFViewer";

const Routers = () => {
  return (
    <Fragment>
      <BrowserRouter basename={"/"}>
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <AuthProvider>
            <Routes>
              <Route path={"/"} element={<PrivateRoute />}>
                <Route
                  exact
                  path={`/`}
                  element={
                    <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />
                  }
                />
                <Route
                  exact
                  path={`/sikeuangan`}
                  element={
                    <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />
                  }
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/transaksi/document/:formId`}
                  element={<PDFViewerComponent />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/umk/document/:formId`}
                  element={<PDFViewerComponentUMK />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/umo/document/:formId`}
                  element={<PDFViewerComponentUMO />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/groupdokumentransaksi/document/:formId`}
                  element={<PDFViewerComponentTandaDiterima />}
                />
                <Route path={`/*`} element={<LayoutRoutes />} />
              </Route>
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/login`}
                element={<Signin />}
              />
              {authRoutes.map(({ path, Component }, i) => (
                <Route path={path} element={Component} key={i} />
              ))}
            </Routes>
          </AuthProvider>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;
